import styled from 'styled-components';

import AlertBox from 'components/ui/AlertBox';

export const StyledAlertBox = styled(AlertBox)`
  margin-bottom: 20px;
`;
